import type { HelpFile } from '../../types/help'
import { RoleAssignmentsTestIds } from '../../../testids/RoleAssignmentsTestIds'

export const roleAssignmentsHelp: HelpFile = {
  docPage: '/docs/access/role-assignments',
  texts: {
    [RoleAssignmentsTestIds.roleAssignmentsList]:
      'Alle Benutzer und ihre zugewiesenen IAM-Anwendungsrollen.',
    [RoleAssignmentsTestIds.colEmail]: null,
    [RoleAssignmentsTestIds.colAssignedRoles]:
      'Zugewiesene IAM-Anwendungsrollen — steuern, was in der IAM-Oberfläche sichtbar und erlaubt ist.',
  },
}
